const getImageMetadata = async (file: File) =>
  await new Promise<{ width: number; height: number }>((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight
      });
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to read image dimensions.'));
    };
    image.src = objectUrl;
  });

const getVideoMetadata = async (file: File) =>
  await new Promise<{
    width: number;
    height: number;
    duration_in_ms: number;
    duration_in_s: number;
  }>((resolve, reject) => {
    const video = document.createElement('video');
    const objectUrl = URL.createObjectURL(file);

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        duration_in_ms: Math.round(video.duration * 1000),
        duration_in_s: Math.round(video.duration)
      });
    };
    video.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to read video metadata.'));
    };
    video.preload = 'metadata';
    video.src = objectUrl;
  });

export const getMediaMetadata = async (file: File, contentType = file.type) => {
  try {
    if (contentType.startsWith('image/')) return await getImageMetadata(file);
    if (contentType.startsWith('video/')) return await getVideoMetadata(file);
  } catch {
    return {};
  }

  return {};
};
